<template>
  <div class="login">
    <div class="content">
      <div class="info">
        <!-- <div v-if="!forgetPasswordShow && !verificationCodeShow && !newPasswordShow && !resetSuccessShow" class="info_left">
          <div class="operating">
            <p class="top-titles">{{ $t("sign_up") }}</p>
            <p class="save_time" style="font-weight: 600">
              {{ $t("save_time_later1") }}
            </p>
            <p class="save_time">{{ $t("save_time_later2") }}</p>
            <button @click="goToRegister()" class="create_btn">
              {{ $t("createAccount") }}
            </button>
          </div>
        </div> -->
        <div v-if="!forgetPasswordShow && !verificationCodeShow && !newPasswordShow && !resetSuccessShow"
             class="info_right">
          <div class="operating">
            <p class="top-titles">{{ $t("sign_in") }}</p>
            <p
              v-if="loginErrorMessage"
              style="padding-bottom: 20px; color: red"
            >
              <b>{{ loginErrorMessage }}</b>
            </p>
            <!-- <p v-if="newPasswordResetMessage" style="padding:10px; border: 1px, solid rgb(3, 211, 252)">
              <h3>{{ newPasswordResetMessage }}</h3>
            </p> -->
            <div class="input_box input_box_top">
              <span style="margin-left: 30px">{{ $t("emailorphone") }}</span>
              <el-input
                :class="[(this.loginErrorEmail && !formLabelAlign.username) ? 'el-input-error' : 'el-input']"
                v-model="formLabelAlign.username"
                :placeholder="[this.loginErrorEmail ? this.loginErrorEmail : $t('enter_email_address_phone')]"
                @keyup.enter.native="Login(formLabelAlign)"
              ></el-input>
            </div>
            <div class="input_box">
              <span style="margin-left: 30px">{{ $t("password") }}</span>
              <el-input
                :class="[
                  (this.loginErrorPassword && !formLabelAlign.password) ? 'el-input-error' : 'el-input',
                ]"
                v-model="formLabelAlign.password"
                type="password"
                :placeholder="[this.loginErrorPassword ? this.loginErrorPassword : $t('enter_password')]"
                @keyup.enter.native="Login(formLabelAlign)"
              ></el-input>
            </div>
            <div class="forgot-pw-container">
              <el-checkbox v-model="rememberMe">{{ $t('remember_me') }}</el-checkbox>
              <p class="forgot-pw" @click="onEnableForgotPassword">{{
                  $t("forgotPassword")
                }}</p>
            </div>
            <button @click="Login(formLabelAlign)">{{ $t("sign_in") }}</button>
          </div>

          <div class="or-line">
            <span>{{ $t("or") }}</span>
          </div>

          <div class="login-types">
            <img
              :class="{'display-none': !this.isApp}"
              @click="logInWithMedia('wechat')"
              src="../assets/img/login_type_wechat.png"
              alt=""
            />
            <img
              @click="logInWithMedia('google')"
              src="../assets/img/login_type_google.png"
              alt=""
            />
            <img
              @click="logInWithMedia('facebook')"
              src="../assets/img/login_type_facebook.png"
              alt=""
            />
            <img
              v-if="this.isIosApp"
              @click="logInWithMedia('apple')"
              src="../assets/img/login_type_apple.png"
              alt=""
            />
            <!-- <img
              @click="logInWithMedia('phone')"
              src="../assets/img/login_type_phone2.png"
              alt=""
            /> -->
          </div>
          <div class="no-account">
            <p>
              {{ $t("noAccount") }}&nbsp;
            </p>
            <p><span @click="goToRegister()">{{ $t("register") }}</span> or <span
              @click="goToGuestCheckout">{{ $t('checkout_as_guest') }}</span></p>
          </div>
          <!-- <div class="operating account" v-show="login===false">
            <p>{{ $t('resetSendEmail') }}</p>
            <p v-if="couldNotFindEmail" style="color: red">{{ $t('noAccountWithEmail') }}</p>
            <div class="input_box">
              <el-input v-model="email" placeholder="Email"></el-input>
            </div>
              <button @click="resetEmailRequest(email)" class="login_btn">{{ $t('submit') }}</button>
              <button @click="ForgotPassword" class="login_btn">{{ $t('cancel') }}</button>
          </div> -->
        </div>

        <div v-if="forgetPasswordShow || verificationCodeShow || newPasswordShow || resetSuccessShow"
             class="info_right_forgot">
          <p class="top-titles">{{ $t("reset_password") }}</p>
          <div v-if="forgetPasswordShow" class="operating">
            <p class="forgot-text">{{ $t("reset_password_text") }}</p>
            <p v-if="true" class="server-error-msg">
              <b>{{ this.resetErrorEmail }}</b>
            </p>
            <div class="input_box">
              <span>{{ $t("emailorphone") }}</span>
              <el-input
                :class="[(this.resetErrorEmail) ? 'el-input-error' : 'el-input']"
                v-model="resetInfo.email"
                :placeholder="$t('enter_email_address_phone')"
              ></el-input>
            </div>
            <button @click="onSendResetEmail">{{ $t("send_code") }}</button>
            <button class="bottom-button" @click="onCancelForgetPassword">{{ $t("cancel") }}</button>
          </div>

          <div v-if="verificationCodeShow" class="operating">
            <p class="forgot-text">{{ $t("verification_code_text") }}</p>
            <p v-if="true" class="server-error-msg">
              <b>{{ this.resetErrorCode }}</b>
            </p>
            <div class="input_box">
              <span>{{ $t("verification_code") }}</span>
              <el-input
                :class="[(this.resetErrorCode) ? 'el-input-error' : 'el-input']"
                v-model="resetInfo.verificationCode"
                :placeholder="$t('enter_code')"
              ></el-input>
            </div>
            <button @click="onSendVerificationCode">{{ $t("confirm") }}</button>
            <button class="bottom-button" @click="onCancelForgetPassword">{{ $t("cancel") }}</button>
          </div>

          <div v-if="newPasswordShow" class="operating">
            <p class="forgot-text">{{ $t("new_password_text") }}</p>
            <p v-if="true" class="server-error-msg">
              <b>{{ this.resetErrorPassword }}</b>
            </p>
            <div class="input_box input_box_top">
              <span>{{ $t("new_password") }}</span>
              <el-input
                :class="[(this.resetErrorPassword) ? 'el-input-error' : 'el-input']"
                v-model="resetInfo.newPassword"
                :placeholder="$t('enter_password')"
                type="password"
              ></el-input>
            </div>
            <div class="input_box">
              <span>{{ $t("reenter_password") }}</span>
              <el-input
                :class="[(this.resetErrorPassword) ? 'el-input-error' : 'el-input']"
                v-model="resetInfo.newPasswordReenter"
                :placeholder="$t('reenter_password')"
                type="password"
              ></el-input>
            </div>
            <button @click="onSendNewPassword">{{ $t("confirm") }}</button>
            <button class="bottom-button" @click="onCancelForgetPassword">{{ $t("cancel") }}</button>
          </div>

          <div v-if="resetSuccessShow" class="operating">
            <p class="forgot-text">{{ $t("reset_success_1") }}</p>
            <p class="forgot-text">{{ $t("reset_success_2") }}</p>
            <button @click="onFinishReset">{{ $t("logIn") }}</button>
          </div>


        </div>

      </div>
    </div>
    <!-- <div class="login-img">
      <img src="../assets/img/login_pic1.png" alt="" />
    </div> -->
    <div class="close-modal">
      <img
        @click="toggleLoginModalVisibility(false)"
        src="../assets/img/closemodal.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import {mapActions, mapState, mapMutations, mapGetters} from "vuex";
import Router from "../router";
import {isUserAuthenticated} from "../store/modules/cart";
import {uni} from '../mixin'

export default {
  name: "login",
  mixins: [uni],
  data() {
    return {
      rememberMe: false,
      guestCheckoutShow: false,
      forgetPasswordShow: false,
      verificationCodeShow: false,
      newPasswordShow: false,
      resetSuccessShow: false,
      resetInfo: {
        email: "",
        verificationCode: "",
        newPassword: "",
        newPasswordReenter: "",
        token: "",
      },
      resetErrorEmail: "",
      resetErrorCode: "",
      resetErrorPassword: "",

      loginErrorEmail: "",
      loginErrorPassword: "",
      labelPosition: "top",
      formLabelAlign: {
        username: "",
        password: "",
      },
      guestCheckoutForm: {
        username: "",
        password: "",
      },
      guestCheckoutErrors: [],
      email: "",
      login: true, //true showlogin; false forget password
      showModal: false,
      showChangeToNewPassword: false,
      newPasswordResetMessage: "",
      verification: "",
      tempToken: "",
      newpassword: "",
      couldNotFindEmail: false,
      verificationCodeFail: false,
    };
  },
  methods: {
    ...mapActions("auth", [
      "LoginRequest",
      "resetEmail",
      "sentVerificationCode",
      "resetPassword",
      'checkUsername',
    ]),
    ...mapMutations('navbar', ['toggleLoginModalVisibility', 'toggleRegisterModalVisibility', 'toggleGuestCheckoutVisiblity']),
    ...mapMutations("auth", ["updateErrorMessage"]),
    ForgotPassword() {
      (this.newPasswordResetMessage = ""),
        // this.loginErrorMessage = '',
        (this.login = !this.login);
    },
    Login(form) {
      this.loginErrorEmail = "";
      this.loginErrorPassword = "";
      this.updateErrorMessage(null);
      if (!form.username) {
        this.loginErrorEmail = this.$t("emailPhoneRequired");
      }
      if (!form.password) {
        this.loginErrorPassword = this.$t("passwordRequired");
      }
      if (form && form.username && form.password) {
        this.LoginRequest(form);
      }
    },
    // resetEmailRequest(email) {
    //   this.couldNotFindEmail = false;
    //   this.resetEmail(email)
    //     .then((res) => {
    //       this.tempToken = res.data;
    //       this.showModal = true;
    //     })
    //     .catch((err) => {
    //       this.couldNotFindEmail = true;
    //     });
    // },
    resetPasswordRequest(password) {
      this.resetPassword({new_password: password, token: this.tempToken})
        .then((res) => {
          Object.assign(this.$data, this.$options.data.call(this));
          this.newPasswordResetMessage =
            "You have successfully reset your password";
        })
        .catch((err) => {
          alert(
            "err resetting the password, please contact AFM for more information"
          );
        });
    },
    sendVerificationCode(code) {
      this.verificationCodeFail = false;
      if (code.length < 6) {
        return;
      }
      this.sentVerificationCode({code, token: this.tempToken})
        .then((res) => {
          this.showModal = false;
          this.tempToken = res.data;
          this.showChangeToNewPassword = true;
        })
        .catch((err) => {
          console.log("catching error sending verification code", err);
          this.verificationCodeFail = true;
        });
    },
    cancelEnteringVerificationCode() {
      this.showModal = false;
    },
    goToRegister() {
      this.toggleLoginModalVisibility(false);
      this.toggleGuestCheckoutVisiblity(false);
      this.toggleRegisterModalVisibility(true);
    },
    goToGuestCheckout() {
      this.toggleRegisterModalVisibility(false);
      this.toggleLoginModalVisibility(false);
      this.toggleGuestCheckoutVisiblity(true);
    },
    resetLoginForm() {
      this.loginErrorEmail = "";
      this.loginErrorPassword = "";
      // this.formLabelAlign.username = "";
      this.formLabelAlign.password = "";
    },
    resetForgetPassword() {
      this.forgetPasswordShow = false,
        this.verificationCodeShow = false,
        this.newPasswordShow = false,
        this.resetSuccessShow = false,
        this.resetInfo = {
          email: "",
          verificationCode: "",
          newPassword: "",
          newPasswordReenter: "",
          token: "",
        };
      this.resetErrorEmail = "";
      this.resetErrorCode = "";
      this.resetErrorPassword = "";
    },
    onEnableForgotPassword() {
      this.forgetPasswordShow = true;
      this.resetLoginForm();
    },
    onCancelForgetPassword() {
      this.resetForgetPassword();
    },
    onSendResetEmail() {
      if (!this.resetInfo.email) {
        this.resetErrorEmail = this.$t("emailRequired");
      } else {
        // this.couldNotFindEmail = false;
        this.resetEmail(this.resetInfo.email)
          .then((res) => {
            this.resetInfo.token = res.data;
            this.forgetPasswordShow = false;
            this.verificationCodeShow = true;
            // this.tempToken = res.data;
            // this.showModal = true;
          })
          .catch((err) => {
            this.resetInfo.token = "";
            this.resetErrorEmail = err.response.data;
            // this.resetErrorEmail = this.$t("emailNotFound");
            // this.couldNotFindEmail = true;
          });
      }
    },
    onSendVerificationCode() {
      if (!this.resetInfo.verificationCode) {
        this.resetErrorCode = this.$t("codeRequired");
      } else {
        //  this.verificationCodeFail = false;
        // if (code.length < 6) {
        //   return;
        // }
        this.sentVerificationCode({code: this.resetInfo.verificationCode, token: this.resetInfo.token})
          .then((res) => {
            this.resetInfo.token = res.data;
            this.verificationCodeShow = false;
            this.newPasswordShow = true;
            // this.showModal = false;
            // this.tempToken = res.data;
            // this.showChangeToNewPassword = true;
          })
          .catch((err) => {
            // this.resetErrorCode = err.response.data;
            this.resetErrorCode = this.$t("codeIncorrect");
            // this.verificationCodeFail = true;
          });
      }
    },
    onSendNewPassword() {
      if (!this.resetInfo.newPassword || !this.resetInfo.newPasswordReenter) {
        this.resetErrorPassword = this.$t("passwordRequired");
      } else if (this.resetInfo.newPassword !== this.resetInfo.newPasswordReenter) {
        this.resetErrorPassword = this.$t("passwordNotMatch");
      } else {
        this.resetPassword({
          new_password: this.resetInfo.newPassword,
          token: this.resetInfo.token,
          code: this.resetInfo.verificationCode
        })
          .then((res) => {
            // Object.assign(this.$data, this.$options.data.call(this));
            this.newPasswordShow = false;
            this.resetSuccessShow = true;
            // this.newPasswordResetMessage = "You have successfully reset your password";
          })
          .catch((err) => {
            console.log("reset password error: ", err.response);
            this.resetErrorPassword = this.$t("server_error");
          });
      }
    },
    onFinishReset() {
      this.resetForgetPassword();
    },
    logInWithMedia(type) {
      switch (type) {
        case 'google':
          this.googleLogin();
          break;
        case 'wechat':
          this.wechatLogin();
          break;
        case 'facebook':
          this.facebookLogin();
          break;
        case 'apple':
          this.appleLogin();
          break;
      }
    },
    googleLogin() {
      if (this.isApp) {
        this.uni.postMessage({
          data: {
            action: 'googleLogin',
            params: {
              link: 'https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=729243143444-mgmsk07p6p6l13cgscc6rlu4sfg16abl.apps.googleusercontent.com&scope=openid%20email&redirect_uri=https%3A%2F%2Fshopafm.com%2Fgoogle-auth2&hd=gmail.com'
            }
          }
        })
        return
      }
      // window.location.href = 'https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=729243143444-mgmsk07p6p6l13cgscc6rlu4sfg16abl.apps.googleusercontent.com&scope=openid%20email&redirect_uri=https%3A%2F%2Fafmstage-web.truckxi.com%2Fgoogle-auth2&hd=gmail.com';
      window.location.href = 'https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=729243143444-mgmsk07p6p6l13cgscc6rlu4sfg16abl.apps.googleusercontent.com&scope=openid%20email&redirect_uri=https%3A%2F%2Fshopafm.com%2Fgoogle-auth2&hd=gmail.com'
    },
    wechatLogin() {
      if (this.isApp) {
        this.uni.postMessage({
          data: {
            action: 'wechatLogin'
          }
        })
        return
      }
      // window.location.href = 'https://open.weixin.qq.com/connect/qrconnect?appid=wx517d4ee68cb91670&redirect_uri=https%3A%2F%2Fafmstage-web.truckxi.com%2Fwechat-auth2&scope=snsapi_login#wechat_redirect';
      window.location.href = 'https://open.weixin.qq.com/connect/qrconnect?appid=wx517d4ee68cb91670&redirect_uri=https%3A%2F%2Fshopafm.com%2Fwechat-auth2&scope=snsapi_login#wechat_redirect';
    },
    facebookLogin() {
      if (this.isApp) {
        this.uni.postMessage({
          data: {
            action: 'facebookLogin',
            params: {
              link: 'https://www.facebook.com/v10.0/dialog/oauth?client_id=1219276968470230&scope=&response_type=code&redirect_uri=https%3A%2F%2Fshopafm.com%2Ffacebook-auth2'
            }
          }
        })
        return
      }
      // window.location.href = 'https://www.facebook.com/v10.0/dialog/oauth?client_id=1219276968470230&scope=&response_type=code&redirect_uri=https%3A%2F%2Fafmstage-web.truckxi.com%2Ffacebook-auth2';
      window.location.href = 'https://www.facebook.com/v10.0/dialog/oauth?client_id=1219276968470230&scope=&response_type=code&redirect_uri=https%3A%2F%2Fshopafm.com%2Ffacebook-auth2'
    },
    appleLogin() {
      this.uni.postMessage({
        data: {
          action: 'appleLogin'
        }
      })
    },
  },
  beforeRouteLeave(to, from, next) {
    if (isUserAuthenticated()) {
      this.$store.dispatch("cart/getCart");
      this.$store.dispatch("auth/fetchCustomerInformation");
    } else {
      // this.$store.dispatch("cart/fetchCartProducts");
      // this.$store.dispatch("auth/fetchCustomerInformation");
    }
    next();
  },
  watch: {
    $route(to, from) {
      this.resetLoginForm();
      this.resetForgetPassword();
    },
    loginModalVisibilityGlobal: function (newVal, oldVal) {
      this.resetLoginForm();
      this.resetForgetPassword();
    },
    loggedIn: function (newVal, oldVal) {
      if (newVal === true) {
        this.toggleLoginModalVisibility(false);
      }
    },
  },
  computed: {
    ...mapState({
      loginErrorMessage: (state) => state.auth.loginErrorMessage,
      loginModalVisibilityGlobal: state => state.navbar.loginModalVisibilityGlobal,
      loggedIn: state => state.auth.loggedIn,
    })
  },
};
</script>
​
​
<style scoped lang="less">
@import "../assets/css/public";
@import "../assets/css/loginNew";
</style>



// WEBPACK FOOTER //
// src/view/loginNew.vue